export enum ProgramGroup {
  POLICY = 'POLICY',
  INIT = 'INIT',
  UPDATED = 'UPDATED',
  POLICY_ACCEPTED = 'POLICY_ACCEPTED',
  POLICY_NOT_ACCEPTED = 'POLICY_NOT_ACCEPTED',
}
